import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSalesContext } from "../Pages/SalesContext";
import SalesTrendHeader from "../Pages/SalesTrendHeader";
import { jwtDecode } from "jwt-decode";
import React from "react";
import CustomerFilters from '../CustomerVisitTracker/Components/CustomerFilters';   
import CustomerVisitTracker from "./Components/CustomerVisitTable";
import { API_BASE_URL } from "../config/config"; 
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../utils/dashboardUtils.js";

interface DecodedToken {
  name: string;
  preferred_username: string;
  email: string;
  user_id: string;
}

const CustomerVisitDashboard: React.FC = () => {
  const { setKpiData } = useSalesContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [userLocation, setUserLocation] = useState<string | null>(null);
  const [headerUsername, setHeaderUsername] = useState<string | null>(null);
  const [refreshTime, setRefreshTime] = useState<string | null>(null);
  useTokenFromQuery("/app/customervisit_dashboard");
  useFetchUserDetails(
    setUserLocation,
    setHeaderUsername,
    setRefreshTime,
    API_BASE_URL,
    "customervisit_dashboard",
    (userDetails) => {
      // Optional: Store in global context
      setKpiData?.(userDetails);
    }
  );

  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();

  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Customer Visit Dashboard"
          userName={headerUsername }
          location={userLocation }
          refreshTime={refreshTime }
        />
        <CustomerFilters user_id={user_id} />
        <CustomerVisitTracker />
      </div>
    </div>
  );
};

export default CustomerVisitDashboard;

